//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storageListApi, storageRecordUserApi, storageRecordSaveApi } from '@/api/administration';
export default {
  name: 'Return',
  components: {
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    }
  },
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      loading: false,
      searchWhere: {
        types: 1,
        page: 0,
        limit: 0,
        status: 1,
        receive: 1
      },
      index: '',
      tableData: [],
      options: [],
      multipleSelection: [],
      mark: ''
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.drawer = false;
      this.reset();
    },
    openBox: function openBox() {
      this.drawer = true;
      this.getOptionData();
    },
    reset: function reset() {
      this.index = null;
      this.tableData = [];
      this.mark = '';
    },
    handleSearch: function handleSearch(e) {
      if (typeof e === 'number') {
        var data = this.options[e];
        if (data.types === 0) {
          this.searchWhere.frame_id = 0;
          this.searchWhere.card_id = data.id;
        } else {
          this.searchWhere.card_id = 0;
          this.searchWhere.frame_id = data.id;
        }
        this.getTableData();
      }
    },
    departmentClose: function departmentClose() {
      this.openStatus = false;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getOptionData: function getOptionData() {
      var _this = this;
      storageRecordUserApi({
        status: 1
      }).then(function (res) {
        _this.options = res.data || [];
      });
    },
    getTableData: function getTableData() {
      var _this2 = this;
      storageListApi(this.searchWhere).then(function (res) {
        _this2.tableData = res.data.list || [];
      });
    },
    handleClear: function handleClear() {
      this.tableData = [];
    },
    // 提交
    handleConfirm: function handleConfirm() {
      if (typeof this.index !== 'number') {
        this.$message.error('请选择归还部门/人员');
      } else if (this.multipleSelection.length <= 0) {
        this.$message.error('请选择归还的物资');
      } else {
        var res = [];
        this.multipleSelection.map(function (value) {
          res.push(value.id);
        });
        var option = this.options[this.index];
        var data = {
          types: 2,
          storage: res,
          mark: this.mark,
          user_type: option.types,
          user_id: option.id
        };
        this.storageRecord(data);
      }
    },
    storageRecord: function storageRecord(data) {
      var _this3 = this;
      this.loading = true;
      storageRecordSaveApi(data).then(function (res) {
        if (res.status == 200) {
          _this3.handleClose();
          _this3.$emit('isOk');
          _this3.resize();
        }
        _this3.loading = false;
        _this3.$message.success('物资归还成功');
      }).catch(function (error) {
        _this3.loading = false;
      });
    }
  }
};